<template>
	<div>
		<div class="comment-wrap_list-center" v-if="commentList && commentList.length > 0">
			<template v-for="item in commentList">
				<!-- 一级评论列表展示 -->
				<div class="comment-wrap_list" :key="item.commentId">
					<div class="list-wrap_info">
						<img class="avatar"
							:src="item.commentUserIcon ? item.commentUserIcon : `${imgPath}/user.png`"
							>
						<div class="name">{{item.commentUserNickname}}</div>
					</div>
					<div class="list-wrap_desc">
						<div class="desc">{{item.content}}</div>
					</div>
					<div class="comment-fot">
						<div class="comment-fot_left d-flex">
							<div class="date">{{item.createTime | getTime}}</div>
							<div class="reply" @click="replyComment(item)">回复</div>
						</div>
						<div class="comment-fot_right d-flex">
							<img class="zan"
								:src="item.likesFlag ? '../../static/zaned.png' : `${imgPath}/zaning.png`"
								>
							<div class="num">{{item.likesNum}}</div>
						</div>
					</div>
				</div>
				<!-- 二级评论展示 -->
				<div class="comment-wrap_list" style="margin-left: 50px;" v-if="item.children && item.children.length > 0">
					<template v-for="child in item.children">
						<div class="list-wrap_info">
							<img class="avatar"
								:src="child.commentUserIcon ? child.commentUserIcon :  `${imgPath}/user.png`"
								>
							<div class="name">
								<div class="name_chi">{{child.commentUserNickname}}</div>
								<div style="font-size:14px;">回复{{child.replyToUserNickname}}</div>
							</div>
						</div>
						<div class="list-wrap_desc">
							<div class="desc">{{child.content}}</div>
						</div>
						<div class="comment-fot">
							<div class="comment-fot_left d-flex">
								<div class="date">{{child.createTime | getTime}}</div>
								<div class="reply" @click="replyComment(child)">回复</div>
							</div>
							<div class="comment-fot_right d-flex">
								<img class="zan" :src="child.likesFlag ? '../../static/zaned.png' : `${imgPath}/zaning.png`"
									>
								<div class="num">{{child.likesNum}}</div>
							</div>
						</div>
					</template>
					<div class="reply-more" v-if="item.children && item.children.length > 1">
						<div class="more" @click="openMoreComment(item)">展开更多回复</div>
						<img class="more_icon" src="../../static/reply.png" >
					</div>
				</div>
			</template>
			<!-- 弹框 -->
		</div>
	</div>
</template>

<script>
import axios from "axios";
	import { getTimer,imgPath} from "../../util/timer.js"
	export default {
		name: "CommentList",
		props: {
			detailObj:Object
		},
		data() {
			return {
				imgPath:imgPath,
				commentList: [], //评论列表
				getHeight: 0,
				dataStatus: "more", //more 上拉显示更多数据  loading  数据加载中  noMore-没有更多了
				pageSize: 10,
				total: 0,
				detail: {}
			};
		},
		filters: {
			getTime(val) {
				return getTimer(val)
			}
		},
		async mounted() {
			if (this.detailObj && this.detailObj.id) {
				this.detail = this.detailObj
				await this.getCommentList()
			} 
		},
		methods: {
			// @回复人
			replyComment(item) {
				this.$emit('openEwm');
			},
			// 回复
			openComment() {
				
			},
			async getCommentList() {
				if (this.detailObj.id) {
					let id = this.detailObj.id.match(/\d+/g)[0];
					const config = {
						method: 'get',
						url: `https://pubmod.hntv.tv/dx-bridge/get-comment-with-article-super-v2?page=1&limit=5&objectId=${id}&typeId=1392047446073212929`,
					}
					const { data } = await axios(config);
					if (data.code === 0) {
						this.commentList = data.result.items
					}
				}
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.comment-ttile {
		display: block;
		font-size:18px;
		color: #666666;
	}

	.comment-wrap_list {
		margin-top:20px;
		border-bottom: 1px solid #ECECEC;

		.list-wrap_info {
			display: flex;
			align-items: center;

			.avatar {
				width: 44px;
				height: 44px;
				border-radius: 50%;
			}

			.name {
				font-size: 18px;
				color: #444444;
				padding-left:10px;
				font-weight: 700;

				.name_chi {
					color: #036EB8;
				}
			}
		}

		.list-wrap_desc {
			margin-top:15px;

			.desc {
				font-size:16px;
				color: #444444;
				line-height: 1.5;
			}

			.img {
				margin-top: 24px;
				width: 100%;
			}
		}

		.comment-fot {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top:10px;
			margin-bottom: 10px;

			.comment-fot_left {
				.date {
					font-size: 14px;
					color: #999999;
				}

				.reply {
					font-size:14px;
					color: #666666;
					padding-left: 10px;
				}
			}

			.comment-fot_right {
				.zan {
					width:18px;
					height: 18px;
				}

				.num {
					padding-left: 10px;
					font-size: 14px;
					color: #6E6E6E;
				}
			}
		}
	}

	.reply-more {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

		.more {
			color: #999999;
			font-size: 14px;
		}

		.more_icon {
			width: 20px;
			height: 10px;
		}
	}
</style>
